export const SET_APPLICATION_LIST_LOADING = 'SET_APPLICATION_LIST_LOADING'
export const SET_APPLICATION_LIST = 'SET_APPLICATION_LIST'
export const SET_RECIPIENTS_LIST_LOADING = 'SET_RECIPIENTS_LIST_LOADING'
export const SET_RECIPIENTS_LIST = 'SET_RECIPIENTS_LIST'
export const UPDATE_RECIPIENTS_LIST = 'UPDATE_RECIPIENTS_LIST'
export const SWAP_RECIPIENTS_LIST = 'SWAP_RECIPIENTS_LIST'
export const SET_ADD_RECIPIENT = 'SET_ADD_RECIPIENT'
export const SET_ORIGINAL_RECIPIENTS_LIST = 'SET_ORIGINAL_RECIPIENTS_LIST'
export const SET_REMOVE_RECIPIENT_LOADING = 'SET_REMOVE_RECIPIENT_LOADING'
export const SET_REMOVE_RECIPIENT = 'SET_REMOVE_RECIPIENT'
export const MAKE_BATCH_CALL_LOADING = 'MAKE_BATCH_CALL_LOADING'
export const SET_RESEND_EMAIL = 'SET_RESEND_EMAIL'
export const SET_RESEND_EMAIL_LOADING = 'SET_RESEND_EMAIL_LOADING'
